// Tremor cx, focusInput, focusRing [v0.0.1], adapted: the accent is the Papel « marca » token.
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cx(...args: ClassValue[]) {
  return twMerge(clsx(...args));
}

export const focusInput = [
  "focus:ring-2",
  "focus:ring-marca/20",
  "focus:border-marca",
];

export const focusRing = [
  "outline outline-offset-2 outline-0 focus-visible:outline-2",
  "outline-marca",
];
